import React, { memo } from "react";
import { withAppState, getAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable, Epg, LiveHero, Modal, Button, Loading, Text } from "../../services/visualLibraryService";
import { resolution } from "../../config/ui/resolutionConfig";
import { defaultFocusPath as headerFocusPath } from "../../components/Header";
import { isUserAccountActive } from "../../services/accountStatusService";
import { getSpSportsPackageDisplayName } from "../../services/sportPackageService";
import { routes } from "../../routes";
import { redirectTo } from "../../services/navigationService";
import { config } from "../../config/config";
import { LayoutStyled, ArrowScrollStyled, StyledPage, WrapperStyled } from "./styles/Styled";
import { isSuitableFor4KPlayback, has4KProgramId } from "../../services/titleDataService";
import { getGlobalButtonFocusPath, getConfigForModalWithCloseButton } from "../../errors/globalButtons";
import {
  showChannelSubscriptionErrorPopupNew,
  isUserSubscribedToChannel,
  isAddonContent,
  showSportPackageSubscriptionErrorPopup,
  isUserSubscribedToSpSportsChannel,
  isStandAloneAddon,
  isMainPackageAddOn,
  getAddOnByName,
  T20ParentAddOn,
  isT20ParentSubscribed,
  isT20AddOn,
  isCricketAddOn,
  isT20ChildSubscribed,
  CricChildAddOn,
  isCricketAcquiresFrom
} from "../../utils/subscriptionUtils";
import { showResolutionModal, showNotLoggedModal, showInvalidStatusModal } from "../../services/modalsService";
import { isSpSportsAddonContent } from "../../services/sportPackageService";
import { getNavigationReferences } from "../../services/navigationService";
import { getSdk } from "../../services/sdkService";
import {
  getUnixTime,
  unixTimeInMinutes,
  getEpgTime,
  getHoursFromUnix,
  getMinutesFromUnix
} from "../../utils/timeStamp";
import { getNumericParentalLevel } from "../../services/parentalControlService";
import {
  sameLayoutRequestIsInProgress,
  setLayoutRequestInProgress,
  unsetLayoutRequestInProgress
} from "../Layout/layoutNetworkUtils";
import { getPath } from "../../utils/getPath";
import { makeAddOnsDeep } from "../../utils/addOnsUtil";
import getTitlesFormattedForCarousels from "../../utils/getTitlesFormattedForCarousels";
import { starz1 as Theme } from "starz-visual-themes";
import { CellMeasurer, CellMeasurerCache, List } from "react-virtualized";
import { TypedCarouselStyled } from "../../styles/shared-styles";
import { FilterCarasoulStyled } from "./styles/Styled";
import { LayoutEmptyStyled } from "../Layout/styles/Styled";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";

//const defaultFocusPath = Epg.defaultFocusPath;
let sdk = null;
const TIME_TO_MILLISECONDS = 1000;
const SECONDS_PER_PIXELS = 10.75;
const YEAR_CONST = 2018;
const TOTAL_TIME_HOURS = 30;
const TOTAL_REDUCE_TIME_HOURS = 15;
const PLAY_FROM_LABEL = "live_screen";
const ButtonModalFocus = withFocusable(Button);
const INITIAL_MODULE = 0;
let epgStartIndex = 0;
let amountOfDownloadedModules = {};
const width = window.innerWidth;
const height = window.innerHeight;

const ListReferenced = props => {
  return (
    <List ref={list => (listRef = list)} {...props}>
      {props.children}
    </List>
  );
};
const ListFocus = withFocusable(ListReferenced);
let listRef = null;
// const epgFilterName = "epgfilter";
const epgListName = "lists";
const epgGridName = "epg";
let progress = 0;
let remaingTime = null;
let filterSlider;
let carosalSlider;

class Live extends React.PureComponent {
  constructor(props) {
    super(props);
    this.epgEvents = React.createRef();
    this.state = {
      filter: "all",
      epgData: null,
      channelTitle: null,
      isExiting: false,
      program: null,
      imageUrl: null,
      text: null,
      channelsStatus: null,
      modules: null,
      nameSection: getPath(this.props),
      subscriptions: getAppState().subscriptions,
      carosalIndex: 0,
      carosalListIndex: 0,
      loading: false,
      showLiveCarousel: true,
      hasMediaContentId: false
    };
    this.switchMainMenuUpDown = this.switchMainMenuUpDown.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
    this.navigateLeft = this.navigateLeft.bind(this);
    this.navigateRight = this.navigateRight.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getEpgFilters = this.getEpgFilters.bind(this);
    this.getEpgData = this.getEpgData.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.getEpgRefreshEvent = this.getEpgRefreshEvent.bind(this);
    this.onClickPoster = this.onClickPoster.bind(this);
    this.isLiveProgram = this.isLiveProgram.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.play = this.play.bind(this);
    this.scrollUpDown = this.scrollUpDown.bind(this);
    this.programData = this.programData.bind(this);
    this.onBack = this.onBack.bind(this);
    this.clearRefreshTimeout = null;
    this.isEpgRefreshed = false;
    this.item = null;
    this.isliveCarosals = false;
    this.startIndex = 0;
    this.getLayout = this.getLayout.bind(this);
    this.rowRenderer = this.rowRenderer.bind(this);
    this.onChangeItem = this.onChangeItem.bind(this);
    this.cache = new CellMeasurerCache({
      defaultHeight: height / 3,
      fixedWidth: true,
      keyMapper: (rowIndex, columnIndex) => {
        if (rowIndex <= 2) {
          return `${rowIndex}-${columnIndex}`;
        }
        if (this.cache._rowHeightCache["2-0"]) {
          return "2-0";
        }
        if (this.cache._rowHeightCache[`${rowIndex - 1}-${columnIndex}`]) {
          return `${rowIndex - 1}-${columnIndex}`;
        }
        return `${rowIndex}-${columnIndex}`;
      }
    });
    this.videoData = null;
    this.deviceBuilt =  null;
    this.epgPreviousHoursFromCurrentHour = null;
    this.epgNextHoursFromCurrentHour = null;
    this.egpStartTimeMilliSeconds = null
    this.egpEndTimeMilliSeconds = null;
    
    this.TypedCarouselStyledMemo = memo(
      props => {
        return <TypedCarouselStyled onClickPoster={i => this.onClickPoster(i,"live")} {...props} />;
      },
      (props, newProps) => {
        return (
          props.style.height !== "auto" &&
          props.style.height !== newProps.style.height &&
          props.style.top !== newProps.style.top &&
          props.className === newProps.className
        );
      }
    );
    this.FilterCarasoulStyledMemo = memo(
      props => {
        return <FilterCarasoulStyled {...props} />;
      },
      (props, newProps) => {
        return (
          props.style.height !== "auto" &&
          props.style.height !== newProps.style.height &&
          props.style.top !== newProps.style.top &&
          props.className === newProps.className
        );
      }
    );
  }
  async scrollUpDown(event,from) {
    if (event.deltaY > 0) {
      // down wheel move
      !from && this.onModulesDown();
      await this.reloadWait(10);
      this.epgEvents.current.onDown();  
    } else if (event.deltaY < 0) {
      // up wheel moves
      !from && this.onModulesUp();
       from && this.epgEvents.current.onUp();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.switchMainMenuUpDown, false);
    document.removeEventListener("keydown", this.enterHandler, false);
    this.resetComponentData();
  }

  async onClickPoster(itemIndex,from) {
    const { history} = this.props;
    
    if(from === 'epg'){

      await this.reloadWait(10);
      const isArrowClicked = this.epgEvents?.current?.state?.isArrowClicked;
      if(isArrowClicked) return;
      const row = this.epgEvents?.current?.state?.currentliveTvIndex;
      const col = this.epgEvents?.current?.state?.selectedProgram;
  
      history.replace({
        state: {
          rowIndex: row,
          colIndex: col,
          scrollToPage: 2,
        }
      });
      this.setState({
        hasMediaContentId: false,
        focusOn: epgGridName
      });
      this.isliveCarosals = false;
      this.props.setFocus(epgGridName);
      this.programData(col, row);
      await this.handleEpgKeyPress();

    } else if(from === 'live') {
      
      const {location} = this.props;
      if(location?.state?.scrollToPage === -1){
        this.intializeFocus();
        this.onModulesDown();
      } 
      this.isliveCarosals = true;
      carosalSlider.goTo(itemIndex);
      this.props.stateActions.setCarouselItemFocus(itemIndex);

      await this.reloadWait(10);
      
      const { id, addonContent } = this.getVideoDataForLiveCarousel();
      id &&
        this.setState({
          hasMediaContentId: true,
          focusOn: epgListName
      });
      await this.playHandler(addonContent);
    } 
  }

  resetComponentData = () => {
    if (this.clearRefreshTimeout) {
      clearTimeout(this.clearRefreshTimeout);
    }
    this.clearRefreshTimeout = null;
    this.isEpgRefreshed = false;
    this.item = null;
    this.isliveCarosals = false;
    // this.existingFiltersArray = null;
    this.videoData = null;
    this.deviceBuilt =  null;
    this.epgPreviousHoursFromCurrentHour = null;
    this.epgNextHoursFromCurrentHour = null;
    this.egpStartTimeMilliSeconds = null
    this.egpEndTimeMilliSeconds = null;
  };

  componentDidUpdate(prevProps, prevState) {
    const { isExiting } = this.state;
    isExiting && !prevState.isExiting && this.confirmModalFocusPath && this.confirmModalFocusPath.props.setFocus();
  }

  async componentDidMount() {
    // Deep call of User Addons to get the payment info for each addons
    makeAddOnsDeep.call(this);

    const { onRef } = this.props;
    document.addEventListener("keydown", this.switchMainMenuUpDown, false);
    document.addEventListener("keydown", this.enterHandler, false);
    onRef && onRef(this);
    this.setState({ loading: true });
    await this.loadLivePageData();
    this.setState({ loading: false });
    // check history
    if (this.props.location.referrer === "/player") {
      if (sessionStorage.getItem("fromEpg") === "yes") {
        await this.intializeFocusonEpg();
      } else {
        this.intializeFocus();
        this.onModulesDown();
      }
    } else {
      this.intializeFocus();
    }
  }


  createTimeDictionary() {
    const startDate = new Date(this.egpStartTimeMilliSeconds * TIME_TO_MILLISECONDS);
    const endDateTime = new Date(this.egpEndTimeMilliSeconds * TIME_TO_MILLISECONDS)?.getTime();
    let timeDictionary = new Object()

    let timeValue = startDate?.getTime();
    while(timeValue <= endDateTime) {
      timeDictionary[`${startDate.getDate()}-${startDate.getHours()}`] = timeValue;
      timeValue = new Date(startDate.setMinutes(startDate.getMinutes() + 60))?.getTime();
    }
    return timeDictionary;
  }
  

  populateTimeDictionary(dictionary, events) {
    let updatedDictionary = {...dictionary};
    Object.entries(updatedDictionary).forEach(([key]) => {
      const indexArr = [];
      events.forEach((event, index) => {
        const eventStartTime = event?.tsStart * TIME_TO_MILLISECONDS;
        const eventStartDate = new Date(eventStartTime);
        const eventStartDateKey = `${eventStartDate?.getDate()}-${eventStartDate?.getHours()}`;
        if (eventStartDateKey === key) {
          indexArr.push(index);
        }
      });
      updatedDictionary[key] = indexArr;
      updatedDictionary = this.populateEmptyArrays(updatedDictionary)
    })
    return updatedDictionary;
  }
  
  populateEmptyArrays(dictionary) {
    const updatedDictionary = {...dictionary}
    let starterIndex = 0;
    Object.entries(updatedDictionary).forEach(([key, value]) => {
      if (value.length === 0) {
        value.push(starterIndex);
      }
      starterIndex = value[value.length - 1];
    })
    return updatedDictionary;
  }

  createEpgDictionary() {
    let epgDictionary = new Object();
    for (let [channelIndex, items] of this.state.epgData?.data?.entries()) {
      let timeDictionary = this.createTimeDictionary();
      const updatedDictionary = this.populateTimeDictionary(timeDictionary, items?.events);
      epgDictionary[channelIndex] = updatedDictionary;
    }
    this.setState({ epgDictionary: epgDictionary })
  }

  async loadLivePageData() {
     /* Get Layout call(nms) to decide the components to load */

    this.deviceBuilt =  await getSdk().systemManager.device.getYear();
    this.epgPreviousHoursFromCurrentHour = this.deviceBuilt !=='' && this.deviceBuilt  < YEAR_CONST ?  -3 : -6;
    this.epgNextHoursFromCurrentHour = this.deviceBuilt !=='' && this.deviceBuilt  < YEAR_CONST ? 12 : 24;
    this.egpStartTimeMilliSeconds = getUnixTime(getEpgTime(this.epgPreviousHoursFromCurrentHour));
    this.egpEndTimeMilliSeconds = getUnixTime(getEpgTime(this.epgNextHoursFromCurrentHour));

     await this.getLayout();
     /* Get Filter  Data */
     this.setState({
       epgData: ""
     });
     const epgData = await this.getEpgData('all');
     epgData && this.setState({ epgData: await this.stuffData(epgData) }, () => {
                this.createEpgDictionary();
              });
     this.isEpgRefreshed = false;
  }

  async intializeFocus() {
    this.props.history.replace({
      state: {
        scrollToPage: -1,
        selectedliveTvList: -1
      }
    });
    this.props.setFocus(headerFocusPath);
  }

  async intializeFocusonEpg() {
    this.props.history.replace({
      state: {
        scrollToPage: 2,
        selectedliveTvList:  0,
        rowIndex: 0,
        colIndex: epgStartIndex
      }
    });

    this.props.setFocus(epgGridName);
    this.programData(epgStartIndex, 0);
  }

  async getLayout(initialModule = INITIAL_MODULE, finalModule = 2, refreshLayout = false) {
    const {
      applicationState: { userRelatedModules },
      stateActions: { showGlobalModal }
    } = this.props;
    sdk = await getSdk();

    if (getAppState().isOnline) {
      if (!sameLayoutRequestIsInProgress(initialModule, finalModule)) {
        try {
          setLayoutRequestInProgress(initialModule, finalModule);
          const modules = await sdk.mediaManager.getLayout(this.state.nameSection, {
            initialModule,
            finalModule,
            ...(!!userRelatedModules &&
              userRelatedModules[`${this.state.nameSection}`] &&
              userRelatedModules[`${this.state.nameSection}`].length && {
                avoidCacheFor: userRelatedModules[`${this.state.nameSection}`]
              }),
            ...(refreshLayout === true && { refreshLayout })
          });

          let showLiveCarousel = true;
          let filteredArray = modules.modules.reduce(function(filtered, module) {
            switch (module.category) {
              case "ListLiveChannels":
                module.type = "LiveChannels";
                if (module?.titles.length === 0) showLiveCarousel = false;
                module?.titles.length !== 0 && filtered.push(module);
                break;
              default:
                filtered.push(module);
            }
            return filtered;
          }, []);

          modules.modules = [...filteredArray];
          unsetLayoutRequestInProgress();
          amountOfDownloadedModules[this.state.nameSection] = modules.modules.filter(module => !!module.titles).length;
          this.setState({ modules });
          this.setState({ showLiveCarousel: showLiveCarousel });
          this.props.applicationState.userRelatedModules = this.getUserRelatedModulesIndexes();
        } catch (error) {
          unsetLayoutRequestInProgress();
          console.log(error);
          this.setState({ loading: false });
        }
      }
    }
  }

  isEnabled = () => !!this.state.modules;
  getUserRelatedModulesIndexes() {
    let {
      applicationState: { userRelatedModules }
    } = this.props;
    if (!userRelatedModules && this.state.modules) {
      const userModulesIndexes = [];
      for (let i = 0; i < this.state.modules.modules.length; i++) {
        this.state.modules.modules[i].isDynamic === true && userModulesIndexes.push(i);
      }
      if (userModulesIndexes.length > 0) {
        this.props.applicationState.userRelatedModules = {};
        return Object.assign(this.props.applicationState.userRelatedModules, {
          [`${this.state.nameSection}`]: userModulesIndexes
        });
      }
    }
    return userRelatedModules;
  }

  async stuffData(epgData) {
    let stuffedEpgData = null;
    const {
      applicationState: { userLogged, addons }
    } = this.props;
    for (let [index] of epgData?.data?.entries()) {
      if (userLogged) {
        let addOn = epgData.data[index].parent_slug ? epgData.data[index].parent_slug : epgData.data[index].slug;
        if (isUserSubscribedToChannel(addons, addOn)) {
          epgData.data[index].isAddonContent = true;
          epgData.data[index].rowIndex = index;
        } else {
          epgData.data[index].isAddonContent = false;
          epgData.data[index].rowIndex = index;
        }
      } else {
        epgData.data[index].isAddonContent = true;
        epgData.data[index].rowIndex = index;
      }
    }
   
    for (let [index, items] of epgData?.data?.entries()) {
      //start
      let hourAtStart = getHoursFromUnix(items.events[0].tsStart);
      let minsAtStart = getMinutesFromUnix(items.events[0].tsStart);
      if (
        hourAtStart > (getEpgTime(this.epgPreviousHoursFromCurrentHour).getHours() === 0 ? 24 : getEpgTime(this.epgPreviousHoursFromCurrentHour).getHours()) ||
        minsAtStart > getEpgTime(this.epgPreviousHoursFromCurrentHour).getMinutes()
      ) {
        let blankNode = {
          tsStart: this.state.startFrom,
          tsEnd: items.events[0].tsStart,
          title: i18n.get("pages.livePage.eventStatus.noprogram"),
          isBlankNode: true
        };
        epgData.data[index].events.unshift(blankNode);
      }
      //end
      let hoursAtEnd = getHoursFromUnix(items.events[items.events.length - 1].tsEnd);
      let minsAtEnd = getMinutesFromUnix(items.events[items.events.length - 1].tsEnd);
      if (
        hoursAtEnd < (getEpgTime(this.epgNextHoursFromCurrentHour).getHours() === 0 ? 24 : getEpgTime(this.epgNextHoursFromCurrentHour).getHours()) ||
        minsAtEnd < getEpgTime(this.epgNextHoursFromCurrentHour).getMinutes()
      ) {
        let blankNode = {
          tsStart: items.events[items.events.length - 1].tsEnd,
          tsEnd: this.state.endTill,
          title: i18n.get("pages.livePage.eventStatus.noprogram"),
          isBlankNode: true
        };

        epgData.data[index].events.push(blankNode);
      }
    }

    for (let [channelIndex, items] of epgData.data.entries()) {
      items.events.forEach((item, index) => {
        if (index !== 0 && index !== items.events.length - 1) {
          let hour = getHoursFromUnix(item.tsEnd);
          let mins = getMinutesFromUnix(item.tsEnd);
          let nextHour = getHoursFromUnix(items.events[index + 1].tsStart);
          let nextMins = getMinutesFromUnix(items.events[index + 1].tsStart);
          if (hour !== nextHour || mins !== nextMins) {
            let blankNode = {
              tsStart: item.tsEnd,
              tsEnd: items.events[index + 1].tsStart,
              title: i18n.get("pages.livePage.eventStatus.noprogram"),
              isBlankNode: true
            };
            epgData.data[channelIndex].events.splice(index + 1, 0, blankNode);
          }
        }
      });
    }

    stuffedEpgData = epgData;
    this.clearRefreshTimeout && clearTimeout(this.clearRefreshTimeout);
    this.getEpgRefreshEvent(stuffedEpgData);
    return stuffedEpgData;
  }

  async getEpgRefreshEvent(allEvents) {
    const currentDate = new Date();
    let liveArray = [];
    allEvents &&
      allEvents.data.length > 0 &&
      allEvents.data.map((channelEvents, index) => {
        channelEvents &&
          channelEvents.events &&
          channelEvents.events.length > 0 &&
          channelEvents.events.map((item, i) => {
            if (this.isLiveProgram(item.tsStart, item.tsEnd)) {
              liveArray.push(item.tsEnd);
            }
          });
      });
    const smallestProgramMilliSeconds = Math.min(...liveArray) * 1000;
    const endDate = new Date(smallestProgramMilliSeconds);
    const refreshTime = (endDate.getTime() - currentDate.getTime()) / 1000;
    if (refreshTime > 0) {
      await this.reloadWait(refreshTime * 1000);
      await this.reloadLivePageData();
    }
  }
  async reloadLivePageData() {
    const globalModal = getAppState().globalModal;
    this.isEpgRefreshed = true;
    this.setState({
       loading: true,
       isExiting: false
       })
      sessionStorage.setItem("fromEpg", "no");
    // sessionStorage.setItem('filterIndex',0);
    this.setState({ carosalIndex: 0 });
    this.props.applicationState.focusedCarouselItemIndex = 0;
    globalModal && this.props.stateActions.hideGlobalModal();
    await this.loadLivePageData();
    this.setState({ loading: false });
    this.isliveCarosals = true;
    this.props.history.replace({
      state: {
        scrollToPage: 0,
        selectedliveTvList: -1
      }
    });
    this.props.setFocus(epgListName);
  }
  reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }

  isLiveProgram(startTime, endTime) {
    const today = new Date();
    let isLive = false;
    if (today >= startTime * TIME_TO_MILLISECONDS && today < endTime * TIME_TO_MILLISECONDS) {
      isLive = true;
    }
    return isLive;
  }

  async getEpgFilters() {
    sdk = await getSdk();
    // TODO: Check if it's possible to create a decorator for this type of async calls (X behaviour for isOnline and another one for !isOnline).
    if (getAppState().isOnline) {
      try {
        let filters = await sdk.mediaManager.getChannelConfig();
        return filters?.data;
      } catch (error) {
        console.log(error);
        this.setState({ loading: false });
      }
    } else {
    }
  }
  async getEpgData(filter) {
    sdk = await getSdk();
    this.setState({
      startFrom: this.egpStartTimeMilliSeconds,
      endTill: this.egpEndTimeMilliSeconds
    });
    // TODO: Check if it's possible to create a decorator for this type of async calls (X behaviour for isOnline and another one for !isOnline).
    if (getAppState().isOnline) {
      try {
        const epg = await sdk.mediaManager.getChannelEvents(
          {
            channels: filter || 'all',
            ts_start: this.state.startFrom,
            ts_end: this.state.endTill,
            lang: i18n.getLocale() || "en",
            pg: getNumericParentalLevel(),
            limit: 9000 // TODO: apply pagination
          }
        );
        this.setState({ loading: false });
        return epg;
      } catch (error) {
        this.setState({ loading: false });
        console.log(error);
      }
    }
  }

  switchMainMenuUpDown = async event => {

    if (this.state.loading) return;
    if (event.keyCode === 38) {
      event.preventDefault();
      event.stopPropagation();
      this.onModulesUp();
    }
    if (event.keyCode === 40) {
      event.preventDefault();
      event.stopPropagation();
      this.onModulesDown();
    }
    if (this.props.applicationState.currentFocus === epgGridName) {
      if (event.keyCode === 39) {
        event.preventDefault();
        event.stopPropagation();
        this.onModulesRight();
      }
      if (event.keyCode === 37) {
        event.preventDefault();
        event.stopPropagation();
        this.onModulesLeft();
      }
    }
  };

  enterHandler = async event => {
    if (event.keyCode === 13) {
      if (
        this.props.applicationState.currentFocus.indexOf("section") >= 0 ||
        this.props.applicationState.currentFocus === epgGridName
      ) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
          hasMediaContentId: false,
          focusOn: epgGridName
        });

        await this.handleEpgKeyPress();
      }
      else if (this.props.applicationState.currentFocus === epgListName) {
        // live carosal player starts from here
        event.preventDefault();
        event.stopPropagation();
        const { id, addonContent } = this.getVideoDataForLiveCarousel();
        id &&
          this.setState({
            hasMediaContentId: true,
            focusOn: epgListName
          });
        await this.playHandler(addonContent);
      }
    }
  };

  closeConfirmModal() {
    const { location } = this.props;
    this.setState({ isExiting: false });
    if (location?.state?.scrollToPage === -1) {
      this.props.setFocus(headerFocusPath);
    } else {
      this.props.setFocus(epgGridName);
    }
  }

  onBack() {
    const globalModal = getAppState().globalModal;
    const { history } = this.props;
    if (this.state.isExiting) {
      // Close exit popup
      this.closeConfirmModal();
      this.props.setFocus(headerFocusPath);
    } else if (this.props.applicationState.currentFocus === "mainMenu") {
      if ((!globalModal || globalModal.dismissable) && config.get().featureToggles.exitAppPopup) {
        this.setState({ isExiting: true });
      }
    } else {
      this.isliveCarosals = false;
      history.replace({
        state: {
          selectedliveTvList: -1,
          scrollToPage: -1
        }
      });
      this.props.setFocus(headerFocusPath);
    }
    return true;
  }

  onModulesUp() {
    if (getAppState().globalModal || this.state.isExiting === true) return;
    getSdk().systemManager.application.checkMagicRemote() ? this.setState({isWheel : true}) : this.setState({isWheel : false})
    const { history, location } = this.props;
    if (location?.state?.scrollToPage === 2) {
      if (location?.state?.scrollToPage === 2) {
          if (location?.state?.selectedliveTvList === -1 ||
            location?.state?.selectedliveTvList === 0) {
      this.props.stateActions.setCarouselItemFocus(0);
      this.isliveCarosals = true;
      history.replace({
        state: {
          selectedliveTvList: -1,
          scrollToPage: 0
        }
      });
      this.props.setFocus(epgListName);
    }
  }
    } else if (location?.state?.scrollToPage === 0) {
      this.props.setFocus(headerFocusPath);
      this.isliveCarosals = false;
      history.replace({
        state: {
          selectedliveTvList: -1,
          scrollToPage: -1
        }
      });
      this.props.setFocus(headerFocusPath);
    }
  }

  onModulesRight() {}

  onModulesLeft() {}

  onModulesDown() {
    if (getAppState().globalModal || (this.state && this.state.isExiting === true)) return;
    getSdk().systemManager.application.checkMagicRemote() ? this.setState({isWheel : true}) : this.setState({isWheel : false})
    const { history, location } = this.props;
    if (location?.state?.scrollToPage === -1) {
      this.props.setFocus(epgListName);
      this.isliveCarosals = true;
      history.replace({
        state: {
          selectedliveTvList: -1,
          scrollToPage: 0
        }
      });
    }
    if (location?.state?.scrollToPage === 0 && this.state.epgData?.data?.length > 0) {
      this.isliveCarosals = false;
      this.programData(epgStartIndex, 0);
      history.replace({
        state: {
          selectedliveTvList: 0,
          scrollToPage: 2
        }
      });
      this.props.setFocus(epgGridName);
    }
  }
  remTime = (startTime, endTime) => {
    const today = new Date();
    const startTime1 = new Date(startTime * TIME_TO_MILLISECONDS);
    const endTime1 = new Date(endTime * TIME_TO_MILLISECONDS);
    const differenceProgramMili = endTime1.getTime() - startTime1.getTime();

    const remMili = endTime1.getTime() - today.getTime();
    let time1 = new Date(remMili);
    let hoursRem = time1.getUTCHours();
    let minutesRem = time1.getUTCMinutes();
    let secondsRem = time1.getUTCSeconds();
    if (secondsRem > 0) {
      minutesRem += 1;
    }

    const totalProgramMinutes = Math.round(differenceProgramMili / 60000);
    const minutes = hoursRem * 60 + minutesRem;
    progress = ((totalProgramMinutes - minutes) * 100) / totalProgramMinutes;

    let remStr = "";
    if (minutesRem === 0 && hoursRem === 0 && secondsRem === 0) {
      remStr = "";
    } else if (minutesRem === 1 && hoursRem === 0) {
      remStr = i18n.get("pages.livePage.time.oneleft");
    } else if (minutesRem === 2 && hoursRem === 0) {
      remStr = i18n.get("pages.livePage.time.twoleft");
    } else if (minutesRem >= 3 && minutesRem <= 10 && hoursRem === 0) {
      remStr = i18n.get(`pages.livePage.time.threeleft`, minutesRem);
    } else if (minutesRem === 60 && hoursRem === 0) {
      remStr = i18n.get("pages.livePage.time.hourleft");
    } else if (minutesRem >= 11 && hoursRem === 0 && minutesRem !== 60) {
      remStr = i18n.get(`pages.livePage.time.minleft`, minutesRem);
    } else if (minutesRem === 0 && hoursRem === 1) {
      remStr = i18n.get("pages.livePage.time.hourleft");
    } else if (minutesRem === 1 && hoursRem === 1) {
      remStr = i18n.get("pages.livePage.time.hourmin");
    } else if (minutesRem === 2 && hoursRem === 1) {
      remStr = i18n.get(`pages.livePage.time.hourmins`, minutesRem);
    } else if (minutesRem >= 3 && minutesRem <= 10 && hoursRem === 1 && minutesRem !== 60) {
      remStr = i18n.get(`pages.livePage.time.onehours`, minutesRem);
    } else if (minutesRem >= 11 && hoursRem === 1 && minutesRem !== 60) {
      remStr = i18n.get(`pages.livePage.time.hor`, minutesRem);
    } else if (minutesRem === 60 && hoursRem === 1) {
      remStr = i18n.get(`pages.livePage.time.h`);
    } else if (minutesRem === 1 && hoursRem === 2) {
      remStr = i18n.get(`pages.livePage.time.hm`);
    } else if (minutesRem === 2 && hoursRem === 2) {
      remStr = i18n.get(`pages.livePage.time.hsms`);
    } else if (minutesRem >= 3 && minutesRem <= 10 && hoursRem === 2) {
      remStr = i18n.get(`pages.livePage.time.hors`, minutesRem);
    } else if (minutesRem >= 11 && hoursRem === 2 && minutesRem !== 60) {
      remStr = i18n.get(`pages.livePage.time.twohours`, minutesRem);
    } else if (hoursRem >= 2 && hoursRem <= 10 && minutesRem === 60) {
      remStr = i18n.get(`pages.livePage.time.threehour`, hoursRem + 1);
    } else if (hoursRem >= 3 && hoursRem <= 10 && minutesRem === 1) {
      remStr = i18n.get(`pages.livePage.time.threeone`, hoursRem);
    } else if (hoursRem >= 3 && hoursRem <= 10 && minutesRem === 2) {
      remStr = i18n.get(`pages.livePage.time.threetwo`, hoursRem);
    } else if (hoursRem >= 3 && hoursRem <= 10 && minutesRem >= 3 && minutesRem <= 10) {
      remStr = i18n.get(`pages.livePage.time.three`, hoursRem, minutesRem);
    } else if (hoursRem >= 3 && hoursRem <= 10 && minutesRem >= 11) {
      remStr = i18n.get(`pages.livePage.time.three`, hoursRem, minutesRem);
    } else if (hoursRem >= 10 && minutesRem === 60) {
      remStr = i18n.get(`pages.livePage.time.ele`, hoursRem + 1);
    } else if (hoursRem >= 11 && minutesRem === 1) {
      remStr = i18n.get(`pages.livePage.time.eleone`, hoursRem);
    } else if (hoursRem >= 11 && minutesRem === 2) {
      remStr = i18n.get(`pages.livePage.time.eletwo`, hoursRem);
    } else if (hoursRem >= 11 && minutesRem >= 3 && minutesRem <= 10) {
      remStr = i18n.get(`pages.livePage.time.elethree`, hoursRem, minutesRem);
    } else if (hoursRem >= 11 && minutesRem >= 11) {
      remStr = i18n.get(`pages.livePage.time.eleplus`, hoursRem, minutesRem);
    }
    return remStr;
  };

  programStatus = (startTime, endTime, title, previousProgram) => {
    let type = "";
    const start = startTime * TIME_TO_MILLISECONDS;
    const end = endTime * TIME_TO_MILLISECONDS;
    const today = Date.now();
    if (title === i18n.get("pages.livePage.eventStatus.noprogram")) {
      type = type;
    } else if (today >= start && today < end) {
      type = i18n.get("pages.livePage.eventStatus.live");
      remaingTime = this.remTime(startTime, endTime);
    } else if (today >= start && today >= end) {
      type = i18n.get("pages.livePage.eventStatus.catchup");
    } else if (today <= start && today < end) {
      type =
        previousProgram?.status === "live"
          ? i18n.get("pages.livePage.eventStatus.upnext")
          : previousProgram?.status == null
          ? i18n.get("pages.livePage.eventStatus.upnext")
          : "";
    }
    return type;
  };

  isLiveProgram = (startTime, endTime) => {
    let type = "";
    const start = startTime * TIME_TO_MILLISECONDS;
    const end = endTime * TIME_TO_MILLISECONDS;
    const today = new Date();
    let isLive = false;
    if (today >= start && today < end) {
      isLive = true;
    }
    return isLive;
  };

  programData(colIndex, rowIndex) {
    if (rowIndex == -1) {
      rowIndex = 0;
    }
    let text;
    let channelsStatus;
    this.setState(
      {
        imageUrl: null,
        channelsStatus: null,
        text: null
      },
      () => {
        const tab = this.state.epgData ? this.state.epgData : null;
        const title = tab?.data[rowIndex];
        const programData = tab?.data[rowIndex].events[colIndex];
        const previousProgram = tab?.data[rowIndex].events[colIndex - 1];
        const obj = programData && "images" in programData;
        let imageUrl = obj ? programData?.images[0]?.url : "";
        imageUrl = imageUrl.replace(".com/", ".com/742w/");
        channelsStatus = title?.isAddonContent;
        const subscriptions = (this.props.applicationState.subscriptions || []);
        const slugName = title?.parent_slug ? title?.parent_slug : title?.slug;
        const addOn = subscriptions && subscriptions.length > 0 && subscriptions.find(subs => subs.name === slugName)
        let displayText = `${i18n.get(`pages.livePage.activate`)} ${addOn?.displayName}`;
        if (!isStandAloneAddon(addOn?.name) && isSpSportsAddonContent(slugName)) {
          displayText = `${i18n.get(`pages.livePage.activate`)} ${getSpSportsPackageDisplayName()}`
        }
        text = channelsStatus == false ? displayText : text;
        this.setState({
          channelTitle: title,
          program: programData,
          previousProgram: previousProgram,
          imageUrl: imageUrl,
          text: text,
          channelsStatus: channelsStatus
        });
      }
    );
  }

  closeModal() {
    this.props.stateActions.hideGlobalModal();
    this.state.focusOn === epgGridName && this.props.setFocus(epgGridName);
    this.state.focusOn === epgListName && this.props.setFocus(epgListName);
  }

  async handleEpgKeyPress() {
    const {
      applicationState: { userLogged, userAccountStatus, addons },
      stateActions,
      location
    } = this.props;
    const events = this.state.epgData.data[location?.state?.rowIndex]?.events[location?.state?.colIndex];
    if (events?.streamingUrl) {
      const addOn = this.state.epgData.data[location?.state?.rowIndex].parent_slug
        ? this.state.epgData.data[location?.state?.rowIndex].parent_slug
        : this.state.epgData.data[location?.state?.rowIndex].slug;
      await this.playHandler(addOn);
    }
  }

  /** Player Handler deciding user is able to  watch the contents, if yes allows to play
   * other wise shows login/subscription/error overlay.
   * */
  async playHandler(addOn) {
    const {
      applicationState: { userLogged, userAccountStatus, addons },
      stateActions
    } = this.props;
    const currentAddOn = getAddOnByName(addOn);

    if (userLogged) {
      if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addOn)) {
        return showInvalidStatusModal.call(this);
      }
      if(isCricketAddOn(addOn) && isCricketAcquiresFrom(addOn)){
        if (!isUserSubscribedToChannel(addons, addOn) && isT20ChildSubscribed(addOn)) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, currentAddOn.displayName);
        } else if (!isUserSubscribedToChannel(addons, addOn) && !isT20ChildSubscribed(addOn)) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, `${currentAddOn.displayName} & ${CricChildAddOn(addOn)?.displayName}`);
        } 
      } else if (isT20AddOn(addOn)) {
        if (!isUserSubscribedToChannel(addons, addOn) && isT20ParentSubscribed(addOn)) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, currentAddOn.displayName);
        } else if (!isUserSubscribedToChannel(addons, addOn) && !isT20ParentSubscribed(addOn)) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, `${T20ParentAddOn(addOn)?.displayName} & ${currentAddOn.displayName}`);
        }
      } else {
          if (isMainPackageAddOn(addOn) && isSpSportsAddonContent(addOn) && !isUserSubscribedToSpSportsChannel(addons, addOn)) {
            return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, getSpSportsPackageDisplayName());
          }
          if (!isMainPackageAddOn(addOn) && !isStandAloneAddon(addOn) && isSpSportsAddonContent(addOn) && !isUserSubscribedToSpSportsChannel(addons, addOn)) {
            return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, getSpSportsPackageDisplayName());
          }
          if (!isUserSubscribedToChannel(addons, addOn)) {
            return showChannelSubscriptionErrorPopupNew.call(this, this.closeModal);
          }
      }

      const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, addOn);
      this.setState({ loading: false });
      if (!isThisDeviceSupported) {
        return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
      }

      if (!!getAppState().isOnline) {
        await showResolutionModal.call(this, isSuitableFor4KPlayback(has4KProgramId.call(this)));
      } else {
        stateActions.showGlobalModal(
          getConfigForModalWithCloseButton(
            {
              title: i18n.get("global.errors.internetConnectivity.title"),
              text: i18n.get("global.errors.internetConnectivity.text")
            },
            this.closeModal.bind(this)
          )
        );
        this.props.setFocus(getGlobalButtonFocusPath("close"));
      }

    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this));
    }
    return false;
  }

  /** Preparing Videodata for LiveCarousel */

  getVideoDataForLiveCarousel = () => {
    const moduleIndex = 0;
    const module = this.state.modules.modules[moduleIndex];
    const { id: moduleId } = module;
    const videoData = carosalSlider.handleAction();
    videoData.moduleId = moduleId;
    return videoData;
  };

  /** Preparing Videodata for EPG program */

  getVideoDataForEPG = is4K => {
    const { location } = this.props;
    let videoData = {};
    const events = this.state.epgData.data[location?.state?.rowIndex].events[location?.state?.colIndex];
    const channelDetails = this.state.epgData.data[location?.state?.rowIndex];
    const startTime = events.tsStart * TIME_TO_MILLISECONDS;
    const endTime = events.tsEnd * TIME_TO_MILLISECONDS;
    const today = new Date();
    const isUpNext = today <= startTime && today < startTime;
    if (!isUpNext) {
      if (events && channelDetails) {
        videoData = {
          videoType: "movie",
          // Dash Widevine is on index 0
          // HLS Playreadey is on index 1 
          manifest: events.streamingUrl[0].url, // getting mpd dash url
          //hardcoded pid
          releasePid: ["kReBER7kBh1T"],
          releaseUrl: "http://link.theplatform.eu/s/qaJAph/kReBER7kBh1T",
          duration: events.duration,
          filmstrip: undefined,
          title: events.title,
          description: events.description,
          playbackTime: 0,
          id: channelDetails.id,
          has4K: is4K,
          externalSubtitles: {},
          addonContent:
            today >= startTime && today >= endTime
              ? "starz"
              : channelDetails.parent_slug
              ? channelDetails.parent_slug
              : channelDetails.slug,
          isLive: today >= startTime && today < endTime ? true : false
        };
      }
    }
    return videoData;
  };

  /** Deciding which content to play */

  async play(is4K) {
    if (this.state.hasMediaContentId) {
      const { id, programType, progress, seriesId, addonContent, moduleId } = this.getVideoDataForLiveCarousel();
      this.isExiting = true;
      sessionStorage && sessionStorage.setItem("fromEpg", "no");
      redirectTo.call(this, routes.player, {
        playFrom: "cw_home",
        videoConfig: { id, progress, seriesId, moduleId, is4K }
      });
    } else {
      const videoData = await this.getVideoDataForEPG(is4K);
      if (Object.keys(videoData).length !== 0) {
        Object.assign(videoData, { playFrom: PLAY_FROM_LABEL });
        //isSelectedFromResolutionPopup && trackEvent(PAGE, is4K ? "4K" : "HD", titleId);
        sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
        sessionStorage && sessionStorage.setItem("fromEpg", "yes");
        this.goPlayer(videoData);
      }
    }
  }

  /** Routing to player with valid video data */

  goPlayer(videoData) {
    const { history } = this.props;
    this.isExiting = true;
    return redirectTo.call(this, routes.player, {
      ...history.location.state,
      ...videoData
    });
  }

  onChangeItem(index) {
    if (this.props.applicationState.currentFocus === epgListName) {
      this.setState({ carosalListIndex: index });
    }
    this.props.stateActions.setCarouselItemFocus(index);
  }

  navigateLeft() {
    if (this.props.applicationState.currentFocus === epgListName) carosalSlider.left();
    this.setState({ isWheel: false });
  }
  navigateRight() {
    if (this.props.applicationState.currentFocus === epgListName) carosalSlider.right();
    this.setState({ isWheel: false });
  }

  onLoad({ startIndex }) {
    epgStartIndex = startIndex;
  }
  onChange({ selectedliveTvList, colIndex, rowIndex }) {
    if (getAppState().globalModal || this.state.isExiting === true) return;
    const { history, location } = this.props;
    // when on epg
    if (location?.state?.scrollToPage === 2 && this.state.epgData?.data?.length > 0) {
      this.props.setFocus(epgGridName);
      this.programData(colIndex, rowIndex);
      history.replace({
        state: {
          selectedliveTvList:  selectedliveTvList,
          rowIndex: rowIndex,
          colIndex: colIndex,
          scrollToPage: location?.state?.scrollToPage
        }
      });
    }
     else if (location?.state?.scrollToPage === 0) {
      this.props.setFocus(epgListName);
    }
  }
  // * Render Components based on modules */

  rowRenderer({ key, index, parent, style }) {
    const carouselLayout = (module, moduleIndex) => (
      <this.TypedCarouselStyledMemo
        key={module?.id}
        type={module?.type?.toLowerCase() === "livechannels" ? "LiveChannels" : "layout"}
        items={getTitlesFormattedForCarousels.call(this, module?.type, module?.titles)}
        carouselIndex={0}
        initialSlide={0}
        className={this.isliveCarosals && "focused"}
        focusPath={epgListName}
        onRef={ref => (carosalSlider = ref)}
        onChangeItem={this.onChangeItem}
        showArrows= {this.state.isWheel ? true  : false}
        MagicRemoteStatus={this.state.isWheel ? true  : false}
        slideMargin={Theme.components.carousel.slideMargin.layout}
        direction={i18n.getDirection()}
        style={style}
        isHero={module?.type?.toLowerCase() === "livechannels" && true}
      />
    );
    const getLayoutRow = index => {
      const module = this.state.modules?.modules[index];
      if (module?.type?.toLowerCase() === "livechannels") {
        return carouselLayout(module, index);
      } else return emptyLayout();
    };
    const emptyLayout = () => {
      return <></>;
    };
    return (
      this.isEnabled() && (
        <CellMeasurer cache={this.cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
          {getLayoutRow(index)}
        </CellMeasurer>
      )
    );
  }

  render() {
    const { location, history } = this.props;
    const { modules } = this.state;
    if (location?.state?.scrollToPage === undefined) {
      history.replace({
        state: {
          scrollToPage: -1
        }
      });
    }

    return this.state.loading ? (
      <Loading overlay opacity="0" />
    ) : (
      <WrapperStyled
      onWheel={e => {
        this.setState({ isWheel: true });
        this.scrollUpDown(e,false);
      }}
      >
      <>
        {this.state.isExiting && ( // FIXME: make this work with globalModal logic when possible (and the other places where is appears too.
          <Modal headingText={i18n.get("global.modals.exit.title")} mainText={i18n.get("global.modals.exit.text")}>
            <ButtonModalFocus
              label={i18n.get("global.no")}
              focusPath="noOkModal_passThru"
              onEnterPress={this.closeConfirmModal}
              onMouseUp={this.closeConfirmModal}
              size="small"
              spacing="small"
              onRef={ref => (this.confirmModalFocusPath = ref)}
              dataSnUp={""}
              dataSnDown={""}
              dataSnLeft={i18n.directionFlip("", "@okModal_passThru")}
              dataSnRight={i18n.directionFlip("@okModal_passThru", "")}
            />
            <ButtonModalFocus
              label={i18n.get("global.yes")}
              focusPath="okModal_passThru"
              onEnterPress={getSdk().systemManager.application.exit}
              onMouseUp={getSdk().systemManager.application.exit}
              size="small"
              dataSnUp={""}
              dataSnDown={""}
              dataSnLeft={i18n.directionFlip("@noOkModal_passThru", "")}
              dataSnRight={i18n.directionFlip("", "@noOkModal_passThru")}
            />
          </Modal>
        )}
        <LayoutStyled
          isVisible={location?.state?.scrollToPage > -1}
          position={
            location?.state?.scrollToPage > -1
              ? resolution.layout.positionHeaderHidden
              : resolution.layout.positionHeaderVisible
          }
        >
          <ArrowScrollStyled
            label={
              this.props.applicationState.userLogged
                ? i18n.get("pages.layout.searchAndMenu")
                : i18n.get("pages.layout.loginAndMenu")
            }
            icon="arrowUp"
            onClick={() => this.onModulesUp(true)}
            isVisible={location?.state?.scrollToPage === 0}
          />

          {location?.state?.scrollToPage <= 0 && modules && this.state.showLiveCarousel && (
            <ListFocus
              height={resolution.live.rowHeight}
              width={width}
              onClickPoster={i => this.onClickPoster(i,"live")}
              rowHeight={sessionStorage.getItem("fromEpg") === "yes" ? resolution.live.rowHeight : this.cache.rowHeight}
              rowRenderer={this.rowRenderer}
              rowCount={1}
              columnCount={1}
              deferredMeasurementCache={this.cache}
              autoContainerWidth
              scrollToAlignment={"center"}
              style={{ overflowY: "hidden", direction: "inherit" }}
              overscanRowCount={1}
              scrollingResetTimeInterval={0}
              onLeft={this.navigateLeft}
              onRight={this.navigateRight}
              focusPath={epgListName}
              onEnterPress={this.enterHandler}
            />
          )}
          {location?.state?.scrollToPage === 2 && <StyledPage className="fixHeight" onWheel={e => {this.setState({ isWheel: true }); this.scrollUpDown(e,true);
              }}>
            {this.state.program && 
              <>
                <LiveHero
                  programInfo={i18n.get("pages.livePage.eventStatus")}
                  programTitle={this.state.program}
                  programData={this.programStatus(this.state.program.tsStart, this.state.program.tsEnd, this.state.program.title, this.state.previousProgram)}
                  timeReming={remaingTime}
                  progress={progress}
                  imageUrl={this.state.imageUrl}
                  textInActive={this.state.text}
                  channelsStatus={this.state.channelsStatus}
                />
              </>
              }
          </StyledPage>
          }
          <div onClick={i => this.onClickPoster(i,"epg")} onWheel={e => {this.setState({ isWheel: true }); this.scrollUpDown(e,true);
              }}>
            {this.state.epgData && this.state.epgData.data.length !== 0 ? (<Epg
              data={this.state.epgData}
              selectedliveTvList={location.state && location?.state?.selectedliveTvList}
              onChange={this.onChange}
              onLoad={this.onLoad}
              programType={i18n.get("pages.livePage.eventStatus")}
              className={location?.state?.scrollToPage === 2 && !this.isliveCarosals && "focused"}
              direction={i18n.getDirection()}
              maxChannelShows={this.state.epgData.total > 4 ? this.deviceBuilt !=='' && this.deviceBuilt < YEAR_CONST ? 2 : 3 : this.state.epgData.total}
              currentFocus={this.props.applicationState.currentFocus}
              timeToStart={this.state.startFrom}
              getCurrentDate={(location?.state?.scrollToPage === 2 && this.state.program ) ? this.state.program.tsStart : getUnixTime(new Date())}
              totalTime={this.deviceBuilt !=='' && this.deviceBuilt < YEAR_CONST ? TOTAL_REDUCE_TIME_HOURS : TOTAL_TIME_HOURS}
              onRef={item => (this.item = item)}
              MagicRemoteStatus= {this.props.applicationState.currentFocus === epgGridName && this.state.isWheel ? true  : false}
              ref={this.epgEvents}
              secondToPixelOffset={SECONDS_PER_PIXELS}
              epgStartTime={this.state.startFrom}
              currentFilter={this.state.currentFilter}
              epgDictionary={this.state.epgDictionary}
            />) : ( this.isEpgRefreshed !== true &&
              <LayoutEmptyStyled>
                <strong><Text text={i18n.get("pages.livePage.noData.emptyDataMsg")} /></strong>
                <Text text={i18n.get("pages.livePage.noData.emptyDataSubMsg")} />
              </LayoutEmptyStyled>)
            }
          </div>
        </LayoutStyled>
      </>
      </WrapperStyled>
    );
  }
}

const Component = withAppState(withSubtheme(Live));
Component.defaultFocusPath = epgGridName;
export default Component;
